<template>
  <div class="home home-page">
    <div class="dashboard mb-5">
      <p class=" v2_font_size_20 font-weight-bold pt-3">
        {{ informHeader }}
      </p>
      <current-study-section
        v-if="!studyIsSubmitted && questionnaire"
        :questionnaire="questionnaire"
        :society="society"
        :user="user"
        :study="study"
        @fill-user-profile="showUserProfilePopup"
      />

      <!-- job preferences -->
      <div class="my-4" v-if="user && user.completedStudyWithJobPreferences">
        <job-profiles-section />
      </div>
    </div>
    <b-modal
      size="xl"
      :visible="isUserProfilePopupVisible"
      class="v3_modal"
      :header-class="'align-items-center border_0'"
      :body-class="'p-0'"
      hide-footer
      @hidden="isUserProfilePopupVisible = false"
    >
      <template slot="modal-header">
        <h2 class="font_size_1125rem">User Profile</h2>
        <div class="d-flex align-items-center justify-content-between">
          <b-button variant="v3_teal_outline" @click="onUserProfileSave">
            <template v-if="!userProfilePopupLoading">Save</template>
            <b-spinner v-else small />
          </b-button>
          <b-button
            variant="v3_red_outline"
            class="ml-3"
            @click="isUserProfilePopupVisible = false"
          >
            Cancel
          </b-button>
        </div>
      </template>
      <user-profile-form
        ref="userProfileModal"
        @profile-form-submit="onProfileSubmit"
        @profile-form-cancel="isUserProfilePopupVisible = false"
        @validate-failed="userProfilePopupLoading = false"
      />
    </b-modal>
  </div>
</template>

<script>
import CurrentStudySection from '@/components/dashboard/CurrentStudySection';
import JobProfilesSection from '@/components/dashboard/JobProfilesSection';
import UserProfileForm from '@/components/users/profile/UserProfileForm';
import Api from '@/providers/Api';
import { CREATE_SURVEY_ACTION } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'NonSocietyHome',
  components: {
    CurrentStudySection,
    JobProfilesSection,
    UserProfileForm,
  },
  props: {
    initialReferModalVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isUserProfilePopupVisible: false,
      userProfilePopupLoading: false,
      questionnaires: null,
    };
  },
  created: function () {
    this.getQuestionnaire();
    this.getQuestionnaires();
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    questionnaire: function () {
      return this.user && this.user.questionnaire
        ? this.user.questionnaire
        : null;
    },
    study: function () {
      return this.questionnaire && this.questionnaire.survey
        ? this.questionnaire.survey
        : null;
    },
    isStudyAvailable: function () {
      return (
        this.questionnaire &&
        this.questionnaire.isActive &&
        !(this.study || {}).submitted
      );
    },
    isPvsStudyAvailable: function () {
      return (
        this.isStudyAvailable && this.questionnaire.is_support_job_preference
      );
    },
    questionnaireLoading: function () {
      return this.$store.state.userQuestionnaireLoading;
    },
    informHeader: function () {
      return this.user.subspecialty
        ? this.user.subspecialty.title
        : this.user.specialty.title;
    },
    studyIsSubmitted: function () {
      return this.study && this.study.submitted;
    },
    society: function () {
      const user = this.$store.state.user;
      return user && user.society_id ? user.society : {};
    },
  },
  methods: {
    showUserProfilePopup: async function () {
      this.isUserProfilePopupVisible = true;
    },
    onUserProfileSave: function () {
      this.userProfilePopupLoading = true;
      this.$refs.userProfileModal &&
        typeof this.$refs.userProfileModal.save === 'function' &&
        this.$refs.userProfileModal.save();
    },
    onProfileSubmit: function () {
      this.userProfilePopupLoading = false;
      this.isUserProfilePopupVisible = false;
      this.beginStudy();
    },
    continueStudy: function () {
      this.$router.push(`/surveyForm/${this.study.id}`);
    },
    beginStudy: async function () {
      try {
        const isUserProfileFilled = await Api.isUserProfileFilled();
        if (!isUserProfileFilled) {
          this.showUserProfilePopup();
          return;
        }
        const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
          questionnaireId: this.questionnaire.id,
        });
        this.$router.push(`/surveyForm/${survey.id}`);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      }
    },
    onSetJobTerms: function () {
      this.study ? this.continueStudy() : this.beginStudy();
    },
    getQuestionnaires: async function () {
      this.questionnaires = await Api.getNonSocietyQuestionnaires();
    },
    getQuestionnaire: async function () {
      if (this.questionnaire) {
        return;
      }
      const questionnaire = await Api.getQuestionnaireById(this.user.questionnaire_id);
      this.$set(this.user, 'questionnaire', questionnaire);
    },
  },
};
</script>
